import { ExclamationIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import React from 'react';
import Button from '../../../components/Button';
import Dialog from '../../../components/Dialog';

const ProjectWizardClearDialog = ({
  visible,
  onCancel,
  onConfirm,
  isClearing,
}) => (
  <Dialog
    title="Clear all changes?"
    visible={visible}
    onCancel={onCancel}
    footer={
      <div className="cluster-2">
        <Button
          data-testid="button-clear-confirm"
          type="danger"
          loading={isClearing}
          onClick={onConfirm}
        >
          Clear changes
        </Button>
      </div>
    }
  >
    <div className="stack-4">
      <p className="text-sm text-neutral-300 dark:text-neutral-300 m-0">
        Are you sure you want to clear all changes?
      </p>
      <div className="cluster-3 items-start rounded-md border border-warning bg-warning-muted dark:bg-neutral-800 p-4 text-on-warning dark:text-warning">
        <ExclamationIcon className="h-5 w-5 flex-shrink-0 mt-0.5" />
        <div className="stack-1">
          <p className="font-medium m-0">
            Project configuration will be reverted.
          </p>
          <p className="text-sm m-0">
            All unpublished changes will be removed and the project
            configuration will be reverted back to the last published version.
          </p>
        </div>
      </div>
    </div>
  </Dialog>
);

ProjectWizardClearDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isClearing: PropTypes.bool,
};

ProjectWizardClearDialog.defaultProps = {
  isClearing: false,
};

export default ProjectWizardClearDialog;
